<div class="layout-container" *ngIf="!!selection">
    <div class="card" *ngIf="currentTextBlock">
        <div class="card-block">


            <div class="form-group row">

                <label
                    class="col-form-label col-xs-6">Move {{currentTextBlock.mediaFormat ? 'Image' : 'Text Block'}}</label>


            </div>

            <div class="btn-group pull-md-right">
                <button class="btn btn-outline-primary btn-sm" [disabled]="firstBlockSelected"
                        (click)="moveText(-1)">Move Up
                </button>
                <button class="btn btn-outline-primary btn-sm" [disabled]="lastBlockSelected"
                        (click)="moveText(1)">Move Down
                </button>
            </div>

            <div class="form-group row" *ngIf="!currentTextBlock.mediaFormat">
                <div class="form-group row ml-1">
                    <div class="btn-group pull-md-right">
                        <button class="btn btn-outline-primary btn-sm" [disabled]="currentSentenceIndex===0"
                                (click)="splitText()">New Block Starting at Sentence
                        </button>
                    </div>
                    <div class="btn-group pull-md-right">
                        <button class="btn btn-outline-primary btn-sm"
                                [disabled]="lastBlockSelected || nextBlockIsImage"
                                (click)="joinText()">Merge with Next Block
                        </button>
                    </div>
                </div>
                <label
                    class="col-form-label col-xs-6">Add Images</label>
                <div class="form-group row ml-1">
                    <div class="btn-group pull-md-right">
                        <button class="btn btn-outline-primary btn-sm"
                                (click)="addImageBefore()">Add Image Before Block
                        </button>
                        <div class="btn-group pull-md-right">
                            <button class="btn btn-outline-primary btn-sm"
                                    (click)="addImageAfter()">Add Image After Block
                            </button>
                        </div>
                    </div>

                </div>
            </div>

            <div *ngIf="currentTextBlock.mediaFormat" class="form-group row">

                <label for="imageSrc" class="col-form-label col-xs-5">Image File Name</label>
                <div class="col-xs-12">
                    <input class="form-control" type="text" [(ngModel)]="currentTextBlock.mediaFormat.source"
                           id="imageSrc">
                </div>
                <label for="imageCaption" class="col-form-label col-xs-5">Image Caption</label>
                <div class="col-xs-12">
                    <input class="form-control" type="text" [(ngModel)]="currentTextBlock.mediaFormat.caption"
                           id="imageCaption">
                </div>
                <!--<label for="imageWidth" class="col-form-label col-xs-5">Width</label>
                <div class="col-xs-4">
                    <input class="form-control" type="text" [(ngModel)]="currentTextBlock.mediaFormat.width"
                           id="imageWidth">
                </div>
                <label for="imageHeight" class="col-form-label col-xs-5">Height</label>
                <div class="col-xs-4">
                    <input class="form-control" type="text" [(ngModel)]="currentTextBlock.mediaFormat.height"
                           id="imageHeight">
                </div>-->
                <label class="col-form-label col-xs-12 ml-0">Delete</label>
                <div class="btn-group pull-md-right ml-1">
                    <button class="btn btn-outline-danger btn-sm"
                            (click)="deleteImage()">Delete Image
                    </button>
                </div>
            </div>
        </div>

        <div class="card-footer">
            <div class="btn-group pull-md-right">
                <button class="btn btn-outline-primary btn-sm" [disabled]="saveInProgress"
                        (click)="saveFinalLayout()">
                    Save
                </button>
            </div>
        </div>

    </div>
</div>
